<template>
  <div class="header-ordos-wrap">
    <div
      class="header-ordos"
      :class="{ 'header-ordos--fixed': isSolidHeader }"
    >
      <div class="header-ordos__inner">
        <img
          class="header-ordos__logo"
          :src="theme.logo"
          :alt="theme.logoAlt"
        />

        <div
          v-if="userInfo && userInfo != ''"
          class="user-state"
          @mouseenter="userOpeShow = true"
          @mouseleave="userOpeShow = false"
        >
          <img
            v-if="userInfo.avatar"
            :src="userInfo.avatar"
            class="user-head-portrait"
          />

          <img
            v-else
            :src="require('@/assets/head-default-personal.png')"
            class="user-head-portrait"
          />

          <span class="user-name">{{ userInfo.nickname || userInfo.phone }}</span>

          <ul class="user-list" v-show="userOpeShow">
            <li class="option">
              <router-link to="/userCenter/material">个人中心</router-link>
            </li>
            <li class="option">
              <router-link to="/userCenter/learning">学习记录</router-link>
            </li>
            <li class="option exit" @click="exitBtn">退出</li>
          </ul>
        </div>

        <div class="user-state" v-else>
          <!-- <router-link class="auth-link" to="/welcomeRegistered">注册</router-link>
          <span class="auth-divider">/</span> -->
          <span class="auth-link login-link" @click="headerLoginBtn">登录</span>
        </div>
      </div>
    </div>

    <Tip
      :text="tipModal.text"
      :ico="tipModal.ico"
      :showBtns="tipModal.showBtns"
      v-if="tipModal.show"
      :fun="tipModal.fun"
      :confirmFun="tipModal.confirmFun"
      :confirmBtnText="tipModal.confirmBtnText"
      :cancelFun="tipModal.cancelFun"
      :cancelBtnText="tipModal.cancelBtnText"
    />
    <Login v-if="loginModal.show" />

    <!-- <div
      class="fixed_right"
      :style="'top:' + rightBoxTop"
    >
      <ul>
        <li
          class="show_more"
          v-if="siteCont && siteCont.waiter_mobile && siteCont.waiter_name"
        >
          <p class="img">
            <img src="@/assets/mask_box/right_icon1.png" alt="" />
          </p>
          <p class="text">联系我们</p>
          <div class="show_text">
            <div class="title_icon">
              <img src="@/assets/mask_box/right_icon_show.png" alt="" />
              <span>联系我们</span>
            </div>
            <div class="phone_list flex">
              <div class="left_text">
                <div class="num"><span>扫码咨询</span></div>
                <div class="num" v-if="!siteCont.waiter_mobile.includes('|')">
                  <span>联系电话</span>{{ siteCont.waiter_mobile }}
                </div>
                <div class="num num2" v-else>
                  <span>联系电话</span>
                  <div>
                    <p>{{ "400-0123-823" }}</p>
                  </div>
                </div>
              </div>
              <div class="code_img">
                <img
                  v-if="siteCont.waiter_qrcode"
                  :src="siteCont.waiter_qrcode"
                  alt=""
                />
                <img v-else src="@/assets/mask_box/code_img.jpg" alt="" />
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import Login from "@/components/pc/login.vue";
import Tip from "@/components/pc/tip.vue";
import { mapState, mapMutations } from "vuex";
import { getNmTheme, resolveNmSiteId } from "@/config/nmTheme";

export default {
  name: "HeaderCf",
  props: ["siteInfo", "logo"],
  components: {
    Login,
    Tip,
  },
  data() {
    return {
      userOpeShow: false,
      isSolidHeader: false,
      rightBoxTop: "50%",
      siteCont: "",
    };
  },
  computed: {
    ...mapState(["loginModal", "userInfo", "tipModal"]),
    siteId() {
      // 域名优先，不用 localStorage / 126 兜底（避免串站先出赤峰 logo）
      return resolveNmSiteId(this.siteCont && this.siteCont.id);
    },
    theme() {
      return getNmTheme(this.siteId) || {};
    },
  },
  watch: {
    siteInfo: {
      handler(val) {
        if (val && val.site_info) {
          this.siteCont = val.site_info;
        }
      },
      immediate: true,
    },
  },
  created() {
    if (localStorage.getItem("siteInfo")) {
      this.siteCont = JSON.parse(localStorage.getItem("siteInfo"));
    }
  },
  mounted() {
    this.GetUserInfo();

    this.handleHeaderScroll();
    window.addEventListener("scroll", this.handleHeaderScroll, { passive: true });
    window.addEventListener("resize", this.handleHeaderScroll);
    window.addEventListener("scroll", this.handleContactSidebarScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleHeaderScroll);
    window.removeEventListener("resize", this.handleHeaderScroll);
    window.removeEventListener("scroll", this.handleContactSidebarScroll);
  },
  methods: {
    ...mapMutations([
      "ShowLoginModal",
      "GetUserInfo",
      "ClearUserInfo",
    ]),

    handleHeaderScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

      // 首屏视频是 100vh，滚到内容区时 header 变成实体固定顶部
      const headerHeight = 72;
      const threshold = window.innerHeight - headerHeight;

      this.isSolidHeader = scrollTop >= threshold;
    },

    handleContactSidebarScroll() {
      const scrollTop = document.documentElement.scrollTop;
      this.rightBoxTop = scrollTop > 200 ? "20%" : "70%";
    },

    headerLoginBtn() {
      this.ShowLoginModal();
    },

    exitBtn() {
      localStorage.removeItem("user");
      localStorage.removeItem("auth");
      localStorage.removeItem("userInfo");

      this.ClearUserInfo();

      if (this.$route.path.includes("userCenter")) {
        this.$router.push("/index");
      } else {
        this.$router.go(0);
      }
    },

    goNewUrl(url) {
      window.open(url);
    },
  },
};
</script>

<style scoped lang="scss">
.header-ordos-wrap {
  position: relative;
  z-index: 1000;
}

.header-ordos {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 72px;
  background: rgba(0, 0, 0, 0.68);
  pointer-events: none;
  transition:
    background 0.25s ease,
    box-shadow 0.25s ease,
    position 0.25s ease;

  &__inner {
    // width: 1500px;
    max-width: calc(100% - 80px);
    height: 72px;
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    pointer-events: auto;
  }

  &__logo {
    height: 40px;
    width: auto;
    display: block;
  }
}

/* 滚动到内容区以后：实体固定头部 */
.header-ordos--fixed {
  position: fixed;
  background: rgba(0, 0, 0, 0.694);
  box-shadow: 0 4px 18px rgba(89, 0, 12, 0.18);
  backdrop-filter: blur(6px);
}

.user-state {
  display: flex;
  align-items: center;
  position: relative;
  height: 72px;
  font-size: 16px;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
  flex-shrink: 0;
}

.auth-link {
  color: #fff;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}

.auth-divider {
  margin: 0 4px;
  color: #fff;
}

.login-link {
  cursor: pointer;
}

.user-head-portrait {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.user-name {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-list {
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 120px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  padding: 6px 0;
  text-shadow: none;
  z-index: 1001;
  pointer-events: auto;

  /* 填补与头部之间的空隙，避免移入菜单时触发 mouseleave */
  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: -8px;
    height: 8px;
  }

  .option {
    line-height: 36px;
    text-align: center;
    font-size: 14px;
    color: #333;
    cursor: pointer;

    a {
      color: #333;
      text-decoration: none;
    }

    &:hover {
      background: #f7f7f7;
    }

    &.exit {
      border-top: 1px solid #eee;
      color: #666;
    }
  }
}

/* 右侧固定「联系我们」 */
.fixed_right {
  position: fixed;
  top: 70%;
  right: 0%;
  margin-left: 600px;
  transform: translate(-50%, 0%);
  width: 80px;
  padding-bottom: 10px;
  background: #ffffff;
  box-shadow: 0px 4px 7px 1px rgba(20, 6, 5, 0.16);
  border-radius: 6px;
  z-index: 12;
}

.fixed_right ul {
  padding-top: 14px;
}

.fixed_right li.line {
  width: 78px;
  height: 1px;
  background: #d0d0d0;
  margin: 17px auto;
}

.fixed_right li p {
  cursor: pointer;
}

.fixed_right li p.img {
  width: 30px;
  height: 30px;
  margin: 0 auto;
}

.fixed_right li p.img img {
  width: 100%;
  height: 100%;
}

.fixed_right li p.text {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #376cec;
  text-align: center;
  margin-top: 15px;
}

li.show_more:hover .show_text {
  display: block;
}

.show_text {
  width: 313px;
  height: 206px;
  background: #ffffff;
  box-shadow: 0px 4px 7px 1px rgba(20, 6, 5, 0.16);
  border-radius: 4px;
  position: absolute;
  right: 95px;
  top: 0;
  z-index: 13;
  display: none;
}

.show_text .title_icon {
  display: flex;
  align-items: center;
  padding: 21px;
}

.show_text .title_icon span {
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #376cec;
  margin-left: 10px;
}

.phone_list {
  background: #e5eaef;
  display: flex;
  min-height: 132px;
}

.left_text {
  padding-top: 12px;
  margin-left: 20px;

  .num2 {
    display: flex;

    p {
      cursor: auto;
    }
  }
}

.phone_list div.num {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #376cec;
  margin-bottom: 5px;
}

.phone_list div.num span {
  color: #222;
  margin-right: 10px;
}

.code_img {
  width: 81px;
  height: 81px;
}

.code_img img {
  width: 100%;
  height: 100%;
  margin-left: 22px;
}
</style>